import { z } from 'zod/v4';
import { Lang } from '../../lang/Lang.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { channelsSchema, deliverableChannelSchema } from './channel-shape.js';
import { propertyItemSchema } from './property-shape.js';
const inputSchema = z.object({});
const outputSchema = z.object({
    properties: z.array(propertyItemSchema),
    referenceId: z.string().nullable(),
    name: z.string(),
    preferredLanguage: z.enum(Lang).nullable(),
    isCompany: z.boolean(),
    isContact: z.boolean(),
    country: z.string().nullable(),
    notes: z.string().nullable(),
    status: z.object({
        isDeceased: z.boolean().nullable(),
        hasGuardian: z.boolean(),
        hasPowerOfAttorney: z.boolean(),
        isCompanyDissolved: z.boolean().nullable(),
        isBankrupt: z.boolean().nullable(),
        addressProtection: z.boolean().nullable(),
    }),
    guardianDetails: z
        .object({
        name: z.string(),
        hasAddress: z.boolean(),
        since: z.iso.date().nullable(),
    })
        .nullable(),
    channels: channelsSchema(deliverableChannelSchema),
    hasAlternativeContacts: z.boolean(),
    otherCaseCountsByStatus: z
        .record(z.string(), z.number().int())
        .describe('Counts of other cases on the same customer, excluding the current case, grouped by case status.'),
    rkiRegistrationCount: z
        .number()
        .int()
        .describe('Number of RKI registrations fetched for this debtor.'),
});
export const getCustomerTool = {
    name: ToolName.GetCustomer,
    category: ToolCategory.CaseInfo,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Return basic information about the debtor on this case: name, preferred language, whether they are a company, contact channels, RKI registration count, and counts of other cases on the same customer. Use the preferred language to decide what language to write debtor-facing content in.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-customer.js.map